// src/shared/api/interceptors/loginRedirect.ts

type LocationLike = { pathname: string; href: string };

/**
 * Hard-navigate to /login after auth has been cleared — unless we're already
 * on the login page. Navigating from /login remounts the app, re-fires
 * whatever unauthenticated call just 401'd, 401s again, and reloads the login
 * page in an infinite loop. (`loc` is injectable because jsdom's
 * window.location is unforgeable in tests.)
 */
export const redirectToLogin = (loc: LocationLike = window.location): void => {
  if (loc.pathname === "/login" || loc.pathname.startsWith("/login/")) return;
  loc.href = "/login";
};
